import React from 'react'
import Form from '@rjsf/mui'
import validator from '@rjsf/validator-ajv8'
import axios from 'axios'
import AddIcon from '@mui/icons-material/AddCircleOutline'
import SimulationIcon from '@mui/icons-material/AutoGraph'
import { JSONSchema7 } from 'json-schema'
import ButtonDialog from '../shared/ButtonDialog'
import { CreateProps } from '../shared/CreateProps'
import { format } from 'date-fns'
import { useAuth } from '../../context/useAuth'

export default function CreateSimulation({ schema, setData, disabled }: CreateProps) {
  const { csrf } = useAuth()
  const [open, setOpen] = React.useState(false)

  return (
    <ButtonDialog
      disabled={disabled}
      title={`Add Simulation`}
      icon={<SimulationIcon />}
      iconButton={<AddIcon fontSize='small' color={disabled ? 'disabled' : 'primary'} />}
      content={
        <Form
          showErrorList={false}
          transformErrors={(errors: any) => {
            return errors.map((error: any) => {
              if (error.name === 'pattern') error.message = 'Invalid simulation_name'
              return error
            })
          }}
          onSubmit={async (e) => {
            // convert ISO strings to required format for backend
            e.formData.start_time = format(new Date(e.formData.start_time), 'yyyy-MM-dd HH:mm')
            e.formData.end_time = format(new Date(e.formData.end_time), 'yyyy-MM-dd HH:mm')
            try {
              const res = await axios.post(`${process.env.REACT_APP_API}`, JSON.stringify(e.formData), {
                headers: {
                  'Content-Type': 'application/json',
                  'X-CSRFToken': csrf,
                },
                withCredentials: true,
              })
              setData(res.data)
              setOpen(false)
            } catch (err) {
              console.log('err:', err)
            }
          }}
          validator={validator}
          schema={schema as JSONSchema7}
        />
      }
      open={open}
      setOpen={setOpen}
    />
  )
}
